import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import "bootstrap/dist/css/bootstrap.min.css";
import CalendarioCitas from "./CalendarioCitas";
import FormularioNuevo from "./FormularioNuevo";
import AdministrarResidentes from "./AdministrarResidentes";
import NavBarSuperior from "./NavBarSuperior";
import HistorialGlobal from "./HistorialGlobal";


const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState("nuevo");
  const [formularios, setFormularios] = useState([]);
  const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [nuevoUsuario, setNuevoUsuario] = useState({ username: "", password: "", role: "" });
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [filtroFechaInicio, setFiltroFechaInicio] = useState("");
  const [filtroFechaFin, setFiltroFechaFin] = useState("");
  const [previewDatos, setPreviewDatos] = useState([]);
  const [vistaPreviaVisible, setVistaPreviaVisible] = useState(false);
  const rol = localStorage.getItem("role");

  const generarReporte = async () => {
    if (!filtroFechaInicio || !filtroFechaFin) {
      return alert("Selecciona ambas fechas");
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/reporte-preview`,
        {
          fechaInicio: filtroFechaInicio,
          fechaFin: filtroFechaFin
        },
        {
          headers: { Authorization: token }
        }
      );

      setPreviewDatos(res.data);  // mostrar datos
      setVistaPreviaVisible(true);
    } catch (err) {
      console.error("❌ Error cargando preview:", err);
      alert("Error cargando vista previa");
    }
  };

  const exportarExcel = async () => {
    if (!filtroFechaInicio || !filtroFechaFin) {
      return alert("Selecciona ambas fechas");
    }
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/reporte-formateado`,
        {
          fechaInicio: filtroFechaInicio,
          fechaFin: filtroFechaFin
        },
        {
          headers: { Authorization: token },
          responseType: "blob"
        }
      );
      const blob = new Blob([res.data], { type: res.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `reporte_residentes_${filtroFechaInicio}_a_${filtroFechaFin}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("❌ Error exportando excel:", err);
      alert("Error exportando excel");
    }
  };

  const token = localStorage.getItem("token");

  const fetchFormularios = useCallback(async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/formulario`,
        {
          headers: { Authorization: token }
        }
      );
      setFormularios(res.data);
    } catch (err) {
      console.error("Error al traer formularios:", err);
    }
  }, [token]);

  useEffect(() => {
    fetchFormularios();
  }, [fetchFormularios]);


  const fetchUsuarios = useCallback(async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/usuarios`,
        {
          headers: { Authorization: token }
        }
      );
      setUsuarios(res.data);
    } catch (err) {
      console.error("Error al traer usuarios:", err);
    }
  }, [token]);
  useEffect(() => {
  if (activeTab === "usuarios") {
      fetchUsuarios();
    }
  }, [activeTab, fetchUsuarios]);

  const handleCrearUsuario = async () => {
    try {
          await axios.post(`${process.env.REACT_APP_API_URL}/register`, nuevoUsuario, {
          headers: { Authorization: token }
        }
      );
      alert("Usuario creado exitosamente");
      setNuevoUsuario({ username: "", password: "", role: "" });
      fetchUsuarios();
    } catch (err) {
      console.error("Error al crear usuario:", err);
      alert("Error al crear usuario");
    }
  };
  const handleActualizarUsuario = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/usuarios/${usuarioSeleccionado._id}`,
        usuarioSeleccionado,
        {
          headers: { Authorization: token }
        }
      );
      alert("Usuario actualizado exitosamente");
      setUsuarioSeleccionado(null);
      fetchUsuarios();
    } catch (err) {
      console.error("Error actualizando usuario:", err);
      alert("Error al actualizar usuario");
    }
  };

  const handleEliminarUsuario = async (id) => {
    try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/usuarios/${id}`, {
          headers: { Authorization: token }
        }
      );
      alert("Usuario eliminado exitosamente");
      fetchUsuarios();
    } catch (err) {
      console.error("Error eliminando usuario:", err);
      alert("Error eliminando usuario");
    }
  };

  // Backup BD function for the backup button
  const backupBD = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/backup`,
        { headers: { Authorization: token }, responseType: "blob" }
      );
      const blob = new Blob([res.data], { type: res.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "backup_base_datos.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error haciendo backup:", err);
      alert("Error haciendo backup");
    }
  };

  const handleGuardarCambios = async () => {
    try {
      const updatePayload = {};
      Object.keys(registroSeleccionado).forEach(campo => {
        if (campo !== '_id' && campo !== '__v' && campo !== 'userId') {
          updatePayload[campo] = registroSeleccionado[campo];
        }
      });

      await axios.put(
        `${process.env.REACT_APP_API_URL}/formulario/${registroSeleccionado._id}`,
        updatePayload,
        { headers: { Authorization: token } }
      );

      alert("Guardado correctamente");
      setRegistroSeleccionado(null);
      fetchFormularios();
    } catch (err) {
      console.error("Error al guardar:", err);
      alert("Error al guardar cambios");
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };
  return (
    <div className="container mt-5">
       <NavBarSuperior />
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-primary">Panel Administrativo</h2>
      </div>

      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "nuevo" ? " active" : ""}`}
            onClick={() => setActiveTab("nuevo")}
          >
            Nuevo Registro
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "historial" ? " active" : ""}`}
            onClick={() => setActiveTab("historial")}
          >
            Historial Global
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "usuarios" ? " active" : ""}`}
            onClick={() => setActiveTab("usuarios")}
          >
            Usuarios
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "residentes" ? " active" : ""}`}
            onClick={() => setActiveTab("residentes")}
          >
            Residentes
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "backup" ? " active" : ""}`}
            onClick={() => setActiveTab("backup")}
          >
            Backup BD
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "citas" ? " active" : ""}`}
            onClick={() => setActiveTab("citas")}
          >
            Citas
          </button>
        </li>
      </ul>

      {activeTab === "nuevo" && (
        <FormularioNuevo
          usuario={localStorage.getItem("username")}
          fetchFormularios={fetchFormularios}
          onSubmit={async (formulario) => {
            try {
              await axios.post(`${process.env.REACT_APP_API_URL}/formulario`, formulario, {
                headers: { Authorization: token }
              });
              alert("Formulario enviado correctamente");
              setActiveTab("historial");
              fetchFormularios();
            } catch (err) {
              console.error("Error al guardar formulario:", err);
              alert("Error al guardar formulario");
            }
          }}
        />
      )}

      {activeTab === "historial" && (
        <HistorialGlobal
          registros={formularios}
          setRegistros={setFormularios}
          modoSupervisor={true}
        />
      )}

      {activeTab === "usuarios" && (
        <div className="card p-4 shadow">
          <h4 className="text-primary mb-4">Administrar Usuarios</h4>
          <div className="border p-3 rounded mb-4">
            <h5>Crear Nuevo Usuario</h5>
            <div className="row g-2">
              <div className="col">
                <input type="text" className="form-control" placeholder="Username" value={nuevoUsuario.username} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, username: e.target.value })} />
              </div>
              <div className="col">
                <input type="password" className="form-control" placeholder="Password" value={nuevoUsuario.password} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, password: e.target.value })} />
              </div>
              <div className="col">
                <select className="form-select" value={nuevoUsuario.role} onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, role: e.target.value })}>
                  <option value="">Selecciona rol</option>
                  <option value="admin">Admin</option>
                  <option value="standard">Standard</option>
                  <option value="supervisor">Supervisor</option>
                </select>
              </div>
              <div className="col">
                <button className="btn btn-primary w-100" onClick={handleCrearUsuario}>Crear Usuario</button>
              </div>
            </div>
          </div>

          <h5>Lista de Usuarios</h5>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Username</th>
                <th>Rol</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map(u => (
                <tr key={u._id}>
                  <td>{u.username}</td>
                  <td>{u.role}</td>
                  <td>
                    <button className="btn btn-warning btn-sm" onClick={() => setUsuarioSeleccionado({...u,password: ""})}>Editar</button>
                    <button className="btn btn-danger btn-sm" onClick={() => handleEliminarUsuario(u._id)}>Eliminar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {usuarioSeleccionado && (
            <div className="card p-3 mt-4">
              <h5>Editar Usuario</h5>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Username"
                value={usuarioSeleccionado.username || ""}
                onChange={(e) =>
                  setUsuarioSeleccionado({ ...usuarioSeleccionado, username: e.target.value })
                }
              />
              <input
                type="password"
                className="form-control mb-2"
                placeholder="Nueva contraseña"
                value={usuarioSeleccionado.password?.startsWith("$2a$") ? "" : (usuarioSeleccionado.password || "")}
                onChange={(e) =>
                  setUsuarioSeleccionado({ ...usuarioSeleccionado, password: e.target.value })
                }
              />
              <select className="form-select mb-2" value={usuarioSeleccionado.role} onChange={(e) => setUsuarioSeleccionado({ ...usuarioSeleccionado, role: e.target.value })}>
                <option value="admin">Admin</option>
                <option value="standard">Standard</option>
                <option value="supervisor">Supervisor</option>
              </select>
              <button className="btn btn-success w-100" onClick={handleActualizarUsuario}>Actualizar Usuario</button>
            </div>
          )}
        </div>
      )}

      {activeTab === "residentes" && rol === "admin" && <AdministrarResidentes />}

      {activeTab === "backup" && (
        <div className="card p-4 shadow">
          <h4 className="text-primary mb-4">Reporte Semanal</h4>

          <div className="row g-3 align-items-end mb-4">
            <div className="col-md-5">
              <label className="form-label">Fecha inicio:</label>
              <input
                type="date"
                className="form-control"
                value={filtroFechaInicio}
                onChange={(e) => setFiltroFechaInicio(e.target.value)}
              />
            </div>
            <div className="col-md-5">
              <label className="form-label">Fecha fin:</label>
              <input
                type="date"
                className="form-control"
                value={filtroFechaFin}
                onChange={(e) => setFiltroFechaFin(e.target.value)}
              />
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button className="btn btn-primary w-100" onClick={generarReporte}>
                Generar Reporte
              </button>
            </div>
          </div>

          {vistaPreviaVisible && (
            <>
              <h5 className="mb-3">Vista previa del reporte</h5>
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead className="table-light">
                      <tr>
                        {Object.keys(previewDatos[0] || {}).map((key, i) => (
                          <th key={i}>{key}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {previewDatos.map((fila, i) => (
                        <tr key={i}>
                          {Object.entries(fila).map(([key, valor], j) => (
                            <td key={j}>
                              {typeof valor === "object" && valor !== null
                                ? Array.isArray(valor)
                                  ? valor.join(", ")
                                  : Object.entries(valor).map(([subKey, subVal]) =>
                                      `${subKey}: ${Array.isArray(subVal) ? subVal.join(", ") : subVal}`
                                    ).join(" | ")
                                : valor}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="text-end mt-3">
                <button className="btn btn-success" onClick={exportarExcel}>Exportar a Excel</button>
              </div>
            </>
          )}

          <hr className="my-5" />

          <div className="text-center">
            <h5 className="mb-3">Backup de Base de Datos</h5>
            <button className="btn btn-secondary w-50" onClick={backupBD}>Backup BD</button>
          </div>
        </div>
      )}

      {activeTab === "citas" && (
        <CalendarioCitas />
      )}

          </div>
        );
      };

export default AdminPanel;
